import { Table } from "@mantine/core";
import { useTranslation } from 'react-i18next';

const ViewAsset = ({ viewAssets, viewAssetPopupStatus, closeViewPopup }) => {
  const { t } = useTranslation();
  return (
  <se-dialog
    id="dialog-complex-view"
    size="large"
    open={viewAssetPopupStatus}
    can-backdrop="false"
  >
    <se-dialog-header>{t('library.viewAsset')}</se-dialog-header>
    <se-dialog-content className="se-dialog-content">
      <div className="container ">
        <div className="col-md-12">
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
              <Table withBorder withColumnBorders>
                <tbody>
                  <tr>
                    <td>{t('library.assetType')}</td>
                    <td>{viewAssets?.type?.type}</td>
                  </tr>
                  <tr>
                    <td>{t('library.assetManufacturer')}</td>
                    <td>{viewAssets?.manufacturer}</td>
                  </tr>
                  <tr>
                    <td>{t('library.assetModel')}</td>
                    <td>{viewAssets?.communicationModel}</td>
                  </tr>
                  {/* <tr>
                    <td>{t('library.version')}</td>
                    <td>{viewAssets?.version}</td>
                  </tr> */}
                  {/* <tr>
                    <td>{t('library.category')}</td>
                    <td>{viewAssets?.assetInfo}</td>
                  </tr> */}

                  <tr>
                    <td>{t('library.assetStatus')}</td>
                    <td>
                      {viewAssets?.validated === true ? t('profile.status.active') : t('profile.status.inactive')}
                    </td>
                  </tr>
                  <tr>
                    <td>{t('library.comments')}</td>
                    <td>{viewAssets?.comments}</td>
                  </tr>
                  <tr>
                    <td>{t('library.createdDate')}</td>
                    <td>{viewAssets?.creationDate}</td>
                  </tr>
                </tbody>
              </Table>
            </div>
          </div>
        </div>
      </div>
    </se-dialog-content>
    <se-dialog-footer>
      <se-button aria-label="library-view-asset-close" onClick={closeViewPopup}>{t('common.cancel')}</se-button>
    </se-dialog-footer>
  </se-dialog>
  );
};

export default ViewAsset;
